import styled from 'styled-components'

export const StyledP = styled.p`
	max-width: ${props => props.textMaxWidth || '100%'};
	font-size: 22px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 38px;
	position: relative;
	top: -10px;
	letter-spacing: normal;
	text-align: ${p => (p.center ? 'center' : 'start')};
	color: ${props => props.textColor || '#797a80'};
	@media (max-width: 768px) {
		line-height: 1.5;
		top: 0px;
	}
	@media (max-width: 425px) {
		top: 0px;
		font-size: 14px;
		${({ center }) =>
			center &&
			`
        text-align: center;
    `}
	}
`
